

let bedFilter = 0;
let bathFilter = 0;
let sqftLowFilter = 500;
let sqftHighFilter = 2500;

let sqftMin = 500;
let sqftMax = 2500;


const showFloorplanClick = function(evt) {
    let className = evt.target.classList;
    if (className != 'downloadPDF') {
        evt.preventDefault();
        let theUnitID = evt.currentTarget.id;

        showFloorplan(theUnitID);
    }
}

const showFloorplan = function(theUnitID) {
    
    var theUnitData = unitList.find(obj => {
        return obj.lotNumber === theUnitID
    })

    //console.log(theUnitData);
    
    let beds = theUnitData.bedRooms;
    let baths = theUnitData.fullBath;
    if (theUnitData.halfBath != 0) {
        baths = baths + ".5";
    }

    let sqft = theUnitData.sqFt;
    let unitNumber = theUnitData.unitName; // theUnitID;

    const nameElem = document.querySelector(".js_unitName");
    const bedElem = document.querySelector(".js_unitBeds span");
    const bathsElem = document.querySelector(".js_unitBaths span");
    const sqftElem = document.querySelector(".js_unitSQFT span");
    const imgElem = document.querySelector(".js-imageSpace");
    const pdfElem = document.querySelector(".js-unitPDF");
    

    //This likely needs to be smarter:
    let fpSVG = theUnitData.multimediaCollection.floorPlans[0].svg;

    let pdf = "";   
    if (theUnitData.multimediaCollection.otherMultimedia) {
        theUnitData.multimediaCollection.otherMultimedia.forEach(mm => {
            if (mm.type == "1030") {
                pdf = mm.link;
            }
        });
    }

    nameElem.innerHTML = unitNumber;
    bedElem.innerHTML = beds;
    bathsElem.innerHTML = baths;
    sqftElem.innerHTML = sqft;
    imgElem.src = fpSVG;
    
    if (pdf != "") {
        pdfElem.href = pdf;
        pdfElem.classList.remove("hide");
    } else {
        pdfElem.href = "#";
        pdfElem.classList.add("hide");
    }

    popupElm.classList.add("open");
}

const closeFloorPlan = function(evt) {
    evt.preventDefault();
    popupElm.classList.remove("open");
}

const closeFloorPlate = function(evt) {
    evt.preventDefault();
    floorPlatePopup.classList.remove("open");
}



const sortListClick = function(evt) {
    evt.preventDefault();
    let sortItem = evt.currentTarget.value;
    evt.currentTarget.classList.toggle("asc");
    let isAsc = evt.currentTarget.classList.contains("asc");

    //turn off currentSort from everywhere but what was clicked on.
    document.querySelectorAll('.currentSort').forEach(elem => {
        elem.classList.remove("currentSort");
    });
    evt.currentTarget.classList.add("currentSort");

    sortList(sortItem, isAsc);
}



const sortList = function(sortItem, isAsc) {

    var listContainer = document.querySelector('.toll-floors-listings');
    var list = document.querySelectorAll('.toll-floors-listings > div');

    const newOrderElem = [ ...list ]; //convert nodeList to array for sorting

    newOrderElem.sort((a,b)=>{
        
        let aa = a.querySelector(`.js-sort-${sortItem}`);
        let bb = b.querySelector(`.js-sort-${sortItem}`);

        if (parseInt(aa.innerText)>parseInt(bb.innerText)) {
            return isAsc?1:-1;
        } else {
            return !isAsc?1:-1;
        }
    });

    newOrderElem.forEach(elem => {
        listContainer.append(elem);
    });


    //This is everything above, but toight. too toight. 
    /* [...list]
    .sort((a,b)=>{
        let aa = a.querySelector(`.js-sort-${sortItem}`);
        let bb = b.querySelector(`.js-sort-${sortItem}`);
        aa.innerText>bb.innerText?1:-1
    })
    .forEach(node=>list.appendChild(node)); */

}


const startList = function(evt) {
    let bedSelection = evt.currentTarget.value;
    bedFilter = parseInt(bedSelection);
    applyFilters();


    sortList("name", true); //intial sort
    var theList = document.getElementById("toll-floors-list");
    var optionDiv = document.getElementById("option_selection");
    theList.classList.add("on");
    optionDiv.classList.add("off");
}













//If clicked outside, then close the filters
const clickOutsideFilters = function(evt) {
    var popupElm = document.getElementById("toll-floors-filter-panel");
    if (!popupElm.contains(evt.target)){ 
        closeFilters();
    }
}

const showFilters = function(evt) {
    var popupElm = document.getElementById("toll-floors-filter-panel");
    popupElm.classList.add("on");

    //close filter on click outside
    setTimeout(function() {
        document.addEventListener('click', clickOutsideFilters);
    }, 1000); //don't detect filter button click
    
}

const closeFilters = function(evt) {
    var popupElm = document.getElementById("toll-floors-filter-panel");
    popupElm.classList.remove("on");
    document.removeEventListener('click', clickOutsideFilters);
}

const setFilterClick = function(evt) {
    
    let myFilter = evt.currentTarget.dataset.filter;
    let count = (evt.currentTarget.classList.contains("increase")) ? 1 : -1;

    let maxBeds = 3;
    let maxBaths = 3;

    if (myFilter == "beds") {
        bedFilter+= count;
        if (bedFilter < -1) bedFilter = -1;
        if (bedFilter > maxBeds) bedFilter = maxBeds;
    } else if (myFilter == "baths") {
        bathFilter+= count;
        if (bathFilter < 0) bathFilter = 0;
        if (bathFilter > maxBaths) bathFilter = maxBaths;
    }

    applyFilters();
}

const clearFilters = function(evt) {
    bedFilter = -1;
    bathFilter = 0;
    sqftLowFilter = 500;
    sqftHighFilter = 2500;
    applyFilters();
}

const getTrackBackground = function(minValue, maxValue, min, max){

    let handleSize = 33;
    

    let halfHandleSize = handleSize/2;
    let trackWidth = track.clientWidth;
    let leftPosition = (((minValue - min) / (max - min)) * ((trackWidth - halfHandleSize) - halfHandleSize)) + halfHandleSize;
    let rightPosition = trackWidth - (((maxValue - max) / (min - max)) * ((trackWidth - halfHandleSize)));

    let gradient = `linear-gradient(90deg, #d6d6d6 ${leftPosition}px, #0070cd ${leftPosition}px, #0070cd ${rightPosition}px, #d6d6d6 ${rightPosition}px)`;
    
     return(`background: ${gradient}`);

}

const onRangeChange = function(evt) {

    const handle = evt.target;
    let minValue = parseInt(minHandle.value);
    let maxValue = parseInt(maxHandle.value);
    let step = 250;

    if (handle === minHandle && minValue > maxValue - step) {
        minHandle.value = maxValue - step;
    }

    if (handle === maxHandle && maxValue - step < minValue) {
        maxHandle.value = minValue + step;
    }

    minValue = parseInt(minHandle.value);
    maxValue = parseInt(maxHandle.value);

    sqftLowFilter = minValue;
    sqftHighFilter = maxValue;

    //Set labels and then filter.
    let theBG = getTrackBackground(minValue, maxValue, sqftMin, sqftMax);
    track.setAttribute("style", theBG);

    applyFilters();
}


const applyFilters = function() {

    //set filter numbers in dom
    const bedValElem = document.querySelector(".js-bedsValue");
    const bathsValElem = document.querySelector(".js-bathsValue");
    const sqftValElem = document.querySelector(".js-sqFtValue");
    const filterCountElem = document.querySelector(".js-filterCount");

    let bedWords = bedFilter;
    if (bedFilter == 0) {
        bedWords = "Studio";
    } else if (bedFilter == -1 ) {
        bedWords = "Any";
    }
    bedValElem.innerHTML = bedWords;
    bathsValElem.innerHTML = (bathFilter == 0) ? "Any" : bathFilter;
    sqftValElem.innerHTML = `${sqftLowFilter} <span>SQ FT</span> - ${sqftHighFilter} <span>SQ FT</span>`

    let filterCount = 0;
    if (bedFilter > 0) filterCount++;
    if (bathFilter > 0) filterCount++;
    filterCountElem.innerHTML = filterCount;



    //Apply filters to list
    var list = document.querySelectorAll('.toll-floors-listings > div');
    list.forEach(function(elem, idx) {
        let beds = elem.querySelector('.js-sort-bedRooms').innerHTML;
        let baths = elem.querySelector('.js-sort-baths').innerHTML;
        let sqft = elem.querySelector('.js-sort-sqft').innerHTML;

        if (beds != bedFilter && bedFilter != -1) {
            elem.classList.add("hideBed");
        } else {
            elem.classList.remove("hideBed");
        }

        if (baths != bathFilter && bathFilter != 0) {
            elem.classList.add("hideBath");
        } else {
            elem.classList.remove("hideBath");
        }

        if (parseInt(sqft) <= sqftHighFilter && parseInt(sqft) >= sqftLowFilter) {
            elem.classList.remove("hideSQFT");
        } else {
            elem.classList.add("hideSQFT");
        }
    })

    
}

const requestInfo = function(evt) {
    //console.log("requestINFO");
    showTBLCForm();
}




const unitButtClick = function(evt) {
    console.log("open Floor Plan: ");
    let me = evt.currentTarget.dataset.name;
    var theOneToOpen = unitList.find(obj => {
        return obj.unitsListArray.includes(me)
    })
    //console.log(openMe);
    showFloorplan(theOneToOpen.lotNumber);
}

const floorPlateSelected = function(evt) {
    let mmid = evt.currentTarget.value;
    var plateData = floorPlates.find(obj => {
        return obj.mmid == mmid
    });

    const svgSpace = document.querySelector(".js-svgSpace");
    floorPlatePopup.classList.add("open");
    

    /* 
    Can't FETCH in old school rollup. should just work in nextjs/reactjs
    let response = await fetch(plateData.svg);

    console.log("go get the thing");
    if(response.ok) {
        console.log(response)
    }else {
        alert("HTTP-Error: " + response.status);
      } */
    


      function reqListener () {
        console.log("loaded SVG");
        svgSpace.innerHTML = this.responseText;

        const unitButts = svgSpace.querySelectorAll(".cls-1 ");
        for (const button of unitButts) {
            button.addEventListener("click", unitButtClick);
            let myUnit = button.dataset.name
            var theUnitData = unitList.find(obj => {
                return obj.unitsListArray.includes(myUnit)
            })
            
            if (theUnitData.bedRooms == 0) {
                button.classList.add("bed_studio");
            } else if (theUnitData.bedRooms == 1) {
                button.classList.add("bed_one");
            } else if (theUnitData.bedRooms == 2) {
                button.classList.add("bed_two");
            } else if (theUnitData.bedRooms == 3) {
                button.classList.add("bed_three");
            }
        }
      }
      
      var oReq = new XMLHttpRequest();
      oReq.addEventListener("load", reqListener);
      oReq.open("GET", plateData.svg);
      oReq.send();
}






const unit_buttons = document.querySelectorAll(".js-showFloorplan");
const closeButton = document.querySelector(".js-closePopup");
const closeFPButton = document.querySelector(".js-closeFPPopup");
const popupElm = document.getElementById("unitPopup");
const floorPlatePopup = document.getElementById("floorPlatePopup");
const sort_buttons = document.querySelectorAll(".js-sortListings");
const filterButton = document.querySelector(".js-toggleFilterPanel");
const closeFilterButton = document.querySelectorAll(".js-closeFilterPanel");
const resetFiltersButton = document.querySelector(".js-resetFilters");
const optionButtons = document.querySelectorAll(".js-optionClick");
const setFilterButtons = document.querySelectorAll(".js-setFilter");
let minHandle = document.getElementById("minHandle");
let maxHandle = document.getElementById("maxHandle");
let track = document.getElementById("rangeTrack");
const rangeSliders = document.querySelectorAll(".js-onRangeChange");
const unitFormBtn = document.querySelector(".js-openForm");
const floorSelector =document.getElementById("toll-floor-mobile-navigation");


if (typeof isUnitPage !== "undefined" && isUnitPage) {
    
    for (const button of unit_buttons) {
        button.addEventListener("click", showFloorplanClick);
    }

    closeButton.addEventListener("click", closeFloorPlan);
    closeFPButton.addEventListener("click", closeFloorPlate);
    
    for (const button of sort_buttons) {
        button.addEventListener("click", sortListClick);
    }

    filterButton.addEventListener("click", showFilters);

    for (const button of closeFilterButton) {
        button.addEventListener("click", closeFilters);
    }

    resetFiltersButton.addEventListener("click", clearFilters);

    for (const button of optionButtons) {
        button.addEventListener("click", startList);
    }

    
    for (const button of setFilterButtons) {
        button.addEventListener("click", setFilterClick);
    }
    
    for (const button of rangeSliders) {
        button.oninput = onRangeChange;
    }

    unitFormBtn.addEventListener("click", requestInfo); //This is in tbcl-contact-form.js

    floorSelector.addEventListener("change", floorPlateSelected);

}
